import * as Yup from "yup"

export const addToBalanceValidation = (t: (val: string) => string) => {
  return Yup.object({
    amount: Yup.string().required(t("common:field_required")),
  })
}

